import { StopNotesAndReferenceNumbers } from "../StopNotesAndReferenceNumbers";
import { CityState, DataSource, Label, Layout, Location, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRecStopEntry extends Layout {
    citystateCityStateZip: CityState;
    labelAdditionalStopDetails: Label;
    layoutStopNotesAndRefNbrs: StopNotesAndReferenceNumbers;
    locationLocation: Location;
    panelAdditionalDetails: Panel;
    panelDropTrailer: Panel;
    panelLocation: Panel;
    panelStopCommentsReferenceNumbers: Panel;
    sourceRecurringOrder: DataSource;
    sourceStopRecOrder: DataSource;
    textboxAddress1: Textbox;
    textboxAddress2: Textbox;
    textboxAppointmentStatusId: Textbox;
    textboxCases: Textbox;
    textboxContactEmail: Textbox;
    textboxContactName: Textbox;
    textboxContactPhone: Textbox;
    textboxLocationId: Textbox;
    textboxLocationName: Textbox;
    textboxStopType: Textbox;
    textboxVolume: Textbox;
    textboxWeight: Textbox;
    textboxZoneId: Textbox;
}
